// Mock data for Bloom Social clone

export const navigationItems = [
  { name: 'Services', href: '#services' },
  { name: 'Process', href: '#process' },
  { name: 'Works', href: '#works' },
  { name: 'FAQ', href: '#faq' },
  { name: 'Reviews', href: '#reviews' }
];

export const trustedCreators = [
  { id: 1, image: 'https://i.pravatar.cc/150?img=12' },
  { id: 2, image: 'https://i.pravatar.cc/150?img=13' },
  { id: 3, image: 'https://i.pravatar.cc/150?img=14' }
];

export const stats = [
  '1000+ Videos Delivered',
  '2x Engagement Boost',
  '4.9 Stars Rating',
  'Top Rated Editors',
  '3+ year expereince',
  'Fast Delivery'
];

export const aboutStats = [
  { value: '1048+', label: 'Videos Delivered' },
  { value: '112+', label: 'Creators Served' },
  { value: '4M+', label: 'Total Views' }
];

export const services = [
  {
    id: 1,
    title: 'Youtube Shorts Editing',
    description: 'We turn raw clips into high-retention, caption-packed vertical videos that pop on Reels, Shorts, and TikTok. Great for content repurposing and explosive growth.',
    tags: ['Snappy Pacing', 'Viral-Ready', 'Subtitled']
  },
  {
    id: 2,
    title: 'Long Form Edits',
    description: 'From vlogs to deep dives, we trim the fluff, tighten the pacing.',
    tags: ['Retention-Driven']
  },
  {
    id: 3,
    title: 'Thumbnail Design',
    description: 'From vlogs to deep dives, we trim the fluff, tighten the pacing.',
    tags: ['Click Magnet']
  },
  {
    id: 4,
    title: 'Content Repurposing Package',
    description: 'One video, 10 pieces of content — cut into Shorts, Reels, quote cards, and teasers. Perfect for creators who want to stay visible everywhere.',
    tags: ['Multi-Platform', 'Batch Delivery', 'Quick']
  }
];

export const processSteps = [
  {
    id: '01',
    title: 'Drop Your Footage',
    description: 'Upload your raw clips — WeTransfer, Google Drive, Dropbox — whatever works for you.',
    image: 'https://images.unsplash.com/photo-1633613286991-611fe299c4be?w=800&h=600&fit=crop'
  },
  {
    id: '02',
    title: 'We Do Our Magic',
    description: 'We cut, trim, color-grade, and add engaging transitions.',
    image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800&h=600&fit=crop'
  },
  {
    id: '03',
    title: 'Feedback? Easy',
    description: 'Want something changed? We offer smooth revision rounds to make sure everything.',
    image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&h=600&fit=crop'
  },
  {
    id: '04',
    title: 'Upload & Grow',
    description: 'We deliver your final video in ready-to-upload YouTube format.',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=800&h=600&fit=crop'
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: 'Long Form: Big Day, Perfectly Edited',
    description: 'From tech reviews to gameplay breakdowns — here\'s a glimpse of how we turn raw footage into binge-worthy content that resonates.',
    views: '2M Views',
    creator: 'Bloom Social',
    thumbnail: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?w=800&h=600&fit=crop',
    videoId: 'akspPfyYdGk'
  },
  {
    id: 2,
    title: 'Master Editing Fast: Core Concepts in Motion',
    description: 'From tech reviews to gameplay breakdowns.',
    views: '1.2M Views',
    creator: 'Work 1',
    thumbnail: 'https://images.unsplash.com/photo-1536240478700-b869070f9279?w=800&h=600&fit=crop',
    videoId: 'r2z5ijYN5Bs'
  },
  {
    id: 3,
    title: 'Meet the Creator Micro 2, Small Size, Big Impact',
    description: 'From tech reviews to gameplay breakdowns.',
    views: '4.2M Views',
    creator: 'Work 2',
    thumbnail: 'https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=800&h=600&fit=crop',
    videoId: 'vP1Okpi69eQ'
  }
];

export const problemSolution = [
  {
    problem: 'Editing takes me forever.',
    solution: 'Done-for-you edits, always on time.'
  },
  {
    problem: 'I miss uploads trying to finish videos.',
    solution: 'Fast turnaround'
  },
  {
    problem: 'I hate editing. I just want to record.',
    solution: 'You record. We handle the rest.'
  },
  {
    problem: 'My videos don\'t look pro enough.',
    solution: 'Cinematic, clean, and branded.'
  },
  {
    problem: 'Captions are a pain to add.',
    solution: 'Burned-in, style-matched captions.'
  }
];

export const reviews = [
  {
    id: 1,
    name: '@mark_locus',
    content: 'Working with Ajin over the past year has been a real asset to our team. They consistently deliver high-quality episode edits, trailers and short-form content, while being reliable and easy to collaborate with. They understand podcast storytelling, pacing and platform requirements very well, which makes the editing process smooth.',
    avatar: 'https://i.pravatar.cc/150?img=68'
  },
  {
    id: 2,
    name: '@tonysa',
    content: 'Whoever\'s editing your videos now… they deserve a raise this was smooth af',
    avatar: 'https://i.pravatar.cc/150?img=33'
  },
  {
    id: 3,
    name: '@johnbai',
    content: 'Editing leveled up big time. Timing, cuts, music — everything\'s just right',
    avatar: 'https://i.pravatar.cc/150?img=15'
  },
  {
    id: 4,
    name: '@chrismaw',
    content: 'Noticed the pacing and flow are so much better lately. You working with someone new?',
    avatar: 'https://i.pravatar.cc/150?img=52'
  },
  {
    id: 5,
    name: '@jemmy',
    content: 'This feels super polished now. Loving the new vibe — your editor is killing it',
    avatar: 'https://i.pravatar.cc/150?img=47'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What types of videos do you edit?',
    answer: 'We specialize in YouTube content — from tech reviews and vlogs to shorts, tutorials, podcasts, and cinematic storytelling. If it\'s for YouTube, we\'ve got it covered.'
  },
  {
    id: 2,
    question: 'How fast is the delivery?',
    answer: 'Typical turnaround is 3-5 business days for standard edits. Rush delivery available for urgent projects.'
  },
  {
    id: 3,
    question: 'Can I request revisions?',
    answer: 'Absolutely! We offer 2 rounds of revisions with every package to ensure you\'re 100% satisfied with the final product.'
  },
  {
    id: 4,
    question: 'Do I need to provide all the footage and assets?',
    answer: 'Yes, please provide all raw footage, music preferences, branding assets, and any specific requirements. We\'ll handle the rest!'
  },
  {
    id: 5,
    question: 'What if I\'m not happy with the result?',
    answer: 'Your satisfaction is our priority. If you\'re not happy after revisions, we\'ll work with you until it\'s right or provide a full refund.'
  }
];

export const contactReasons = [
  'Business Inquiry',
  'Want My Videos Edited',
  'Send Me Samples',
  'Long-Term Collaboration'
];
